var _circle, _circle2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.625,
    cy: 9.75,
    r: 1.25,
    stroke: "#523A48",
    strokeWidth: 0.9375
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.375,
    cy: 9.75,
    r: 1.25,
    stroke: "#523A48",
    strokeWidth: 0.9375
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 9.73278C2.43955 9.69861 2.01194 9.59665 1.70765 9.29235C1.40335 8.98806 1.30139 8.56045 1.26722 7.875M5.625 9.75H9.375M11.875 9.73278C12.5605 9.69861 12.9881 9.59665 13.2924 9.29235C13.75 8.83471 13.75 8.09814 13.75 6.625V5.375H10.8125C10.3472 5.375 10.1145 5.375 9.92623 5.31382C9.54568 5.19017 9.24733 4.89182 9.12368 4.51127C9.0625 4.32298 9.0625 4.09032 9.0625 3.625C9.0625 2.92702 9.0625 2.57803 8.97073 2.29559C8.78526 1.72477 8.33773 1.27724 7.76691 1.09177C7.48447 1 7.13548 1 6.4375 1H1.25",
    stroke: "#523A48",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3.5H5",
    stroke: "#523A48",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 5.375H3.75",
    stroke: "#523A48",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0625 2.25H10.2008C11.1104 2.25 11.5651 2.25 11.9353 2.47107C12.3054 2.69214 12.521 3.09257 12.9522 3.89344L13.75 5.375",
    stroke: "#523A48",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckDelivery);
export default __webpack_public_path__ + "static/media/truck-delivery.004376554b0f996ac9cdeb7936977902.svg";
export { ForwardRef as ReactComponent };